import React from "react";
// declare type SingleComboBoxContext = {
// 	kind: "single",
// 	selectedIndex: number,
// } & ComboBoxContextBaseType
// declare type MultiComboBoxContext = {
// 	kind: "multi",
// 	selectedIndices: number[],
// } & ComboBoxContextBaseType
// declare type ComboBoxContextType = SingleComboBoxContext | MultiComboBoxContext
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const ComboBoxContext = React.createContext(null);
ComboBoxContext.displayName = "ComboBoxContext";
